import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivityStore } from 'src/app/stores/resources/activity.store';
import { DataService } from 'src/app/services/data.service';
import { pushObjArray } from 'src/app/services/convert.service';

@Component({
  selector: 'app-add-sentece-structure',
  templateUrl: './add-sentece-structure.component.html',
  styleUrls: ['./add-sentece-structure.component.scss']
})
export class AddSenteceStructureComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  form: FormGroup;
  answer: AbstractControl;
  isCorrect: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;
  TITLE = 'Add new option';

  constructor(
    public dialogRef: MatDialogRef<AddSenteceStructureComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public store: ActivityStore,
    private ds: DataService,
  ) { }

  ngOnInit() {
    const { ANSWER } = this.data;
    this.form = this.fb.group({
      answer: [ANSWER ? ANSWER.name : null, Validators.compose([Validators.required])],
    })
    if (ANSWER) {
      this.TITLE = "Edit option";
    }
  }


  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    this.error = null;
    if (this.form.valid) {
      const { answer } = f;
      const { ANSWER } = this.data;
      const answers =this.store.options
      const row = {
        key: ANSWER ? ANSWER.key : this.ds.createId(),
        name: `${answer}`,
      };
      const options = pushObjArray(answers, row)
      this.store.options = options;
      this.form.reset();
      this.inputEl.nativeElement.focus();
      if(!isNew){
        this.dialogRef.close('yes')
      }
      if (ANSWER) {
        this.dialogRef.close('yes')
      }
    }
  }
}